<!-- Single trigger button -->
<div class="saved-filters-container">
  <button 
    #triggerBtn
    class="saved-filters-trigger"
    [class.has-saved]="savedFilters.length > 0"
    [class.can-save]="hasActiveFilters"
    [class.active]="isOpen"
    (click)="toggle()"
    [ngxTippy]="hasActiveFilters ? 'Saved filters (can save current)' : 'Saved filters'"
  >
    <mat-icon>{{ hasActiveFilters ? 'bookmark_add' : 'bookmarks' }}</mat-icon>
    <span class="filter-count" *ngIf="savedFilters.length > 0">{{ savedFilters.length }}</span>
  </button>
</div>

<!-- The dropdown is rendered in a portal-like way at the end of body via the data-header -->
